import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

interface HorizontalScrollIndicatorProps {
  visible?: boolean;
}

export default function HorizontalScrollIndicator({ visible = true }: HorizontalScrollIndicatorProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (!isMobile || !visible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: -22,
        right: 8,
        zIndex: 9999,
        pointerEvents: 'none',
        opacity: 0.9,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontSize: '11px',
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.paper,
          padding: '2px 6px',
          borderRadius: '4px',
          border: `1px solid ${theme.palette.divider}`,
          whiteSpace: 'nowrap',
        }}
      >
        ← Swipe to scroll →
      </Typography>
    </Box>
  );
}
